import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Contribution } from '../../models/contribution.model';
import { ContributionApi } from '../contribution.api';

@Injectable({
  providedIn: 'root',
  useClass: ContributionApi,
})
export abstract class IContributionApi {

  abstract getContributionSummary(userId?: number): Observable<Contribution>;
}
